<script>
export default {
  functional: true,
  render(createElement, context) {
    const type = 'is-text'
    const data = {
      ...context.data,
      class: '!tw-h-[32px] lg:!tw-h-[40px] text-button',
      props: {
        type,
      },
    }

    return createElement('b-button', data, context.children)
  },
}
</script>

<style lang="postcss" scoped>
.text-button {
  font-family: 'Exo 2', sans-serif;
  @apply tw-text-[#2F2B31] tw-text-sm tw-leading-[19px] tw-tracking-[-0.01em] tw-font-semibold tw-no-underline;
}
</style>
